import { post, get, deletefn, putfun } from './http.js'
export default {
  // 充值套餐列表
  async vipCombo (params) {
    return await get ('/common/recharge-combo',params)
  },
}



// WEBPACK FOOTER //
// ./src/request/vip.js